import { DeliveryEventType, DeliveryNoteLifecycleCode } from './myDataDelivery.interface';

export enum RECEIVING_NOTE_PURPOSE {
  NON_OBLIGATORY_ISSUER = 1, // ΜΗ ΥΠΟΧΡΕΟΣ ΕΚΔΟΣΗΣ
  DENIAL_OR_OMISSION_OF_ISSUANCE = 2, // ΑΡΝΗΣΗ ΕΚΔΟΣΗΣ/ΕΚ ΠΑΡΑΔΡΟΜΗΣ ΜΗ ΕΚΔΟΣΗ
  INTRA_COMMUNITY_ACQUISITION = 3, // ΕΝΔΟΚΟΙΝΟΤΙΚΗ ΑΠΟΚΤΗΣΗ
  ACQUISITION_FROM_THIRD_COUNTRY = 4, // ΑΠΟΚΤΗΣΗ ΑΠΟ ΤΡΙΤΗ ΧΩΡΑ
  QUANTITY_CHECK = 5, // ΠΟΣΟΤΙΚΟΣ ΕΛΕΓΧΟΣ — only valid for 10.1
  NON_OR_PARTIAL_DELIVERY = 6, // ΜΗ/ΜΕΡΙΚΗ ΠΑΡΑΔΟΣΗ
  OTHER = 7, // ΛΟΙΠΕΣ ΠΕΡΙΠΤΩΣΕΙΣ (requires otherReceivingNotePurposeTitle)
}

export interface AadeBookInvoiceType {
  uid: string;
  mark: number;
  cancelledByMark?: number;
  authenticationCode?: string;
  transmissionFailure?: 1 | 2 | 3 | 4; //
  issuer: PartyType;
  counterpart: PartyType;
  invoiceHeader: InvoiceHeaderType;
  paymentMethods?: {
    paymentMethodDetails: PaymentMethodDetailType | PaymentMethodDetailType[];
  };
  invoiceDetails: InvoiceRowType | InvoiceRowType[];
  taxesTotals?: {
    taxes: TaxTotalsType[];
  };
  invoiceSummary: InvoiceSummaryType;
  qrCodeUrl?: string;
  downloadingInvoiceUrl?: string;
  /**
   * This not returned when doc is in REGISTERED status
   * Not sure why
   */
  invoiceDeliveryStatus?: DeliveryNoteLifecycleCode;
  deliveryLifecycle?: {
    deliveryEvents: DeliveryEventType[];
  };
}

export interface PartyType {
  vatNumber: string;
  country: string;
  branch: number; // val >= 0
  name: string;
  address: AddressType;
  documentIdNo: string; // Max length 100
  supplyAccountNo: string; // Max length 100
  countryDocumentId: string; // Κωδικοί χωρών
}

interface AddressType {
  street?: string;
  number?: string;
  postalCode: string;
  city: string;
}

export interface InvoiceHeaderType {
  series: string; // Σειρά παραστατικού, max length 50
  aa: string; // Serial number, max length 50
  issueDate: Date; // Ημ. Έκδοσης Παραστατικού - YYYY-MM-DD
  invoiceType: string; // Είδος Παραστατικού, Check comment below
  vatPaymentSuspension?: boolean; // Αναστολή Καταβολής ΦΠΑ
  currency?: string; // Κωδικοί νομισμάτων
  exchangeRate?: number; // Ισοτιμία, decimal minVal=0, 5 decimal points
  correlatedInvoices?: string; // Συσχετιζόμενα Παραστατικά
  selfPricing?: boolean; // Ένδειξη Αυτοτιμολόγησης
  dispatchDate?: string; // Date, Ημερομηνία Έναρξης Αποστολής
  dispatchTime?: string; // Time, Ώρα Έναρξης Αποστολής
  vehicleNumber?: string; // Αριθμός Μεταφορικού Μέσου
  movePurpose?: number; // Σκοπός Διακίνησης, Ελάχιστη τιμή = 1, Μέγιστη τιμή = 20
  isDeliveryNote?: boolean; // Ένδειξη Παραστατικού Διακίνησης
  fuelInvoice?: boolean; // Παραστατικό καυσίμων (ένδειξη), Αποδεκτό μόνο στην περίπτωση αποστολής από παρόχους.
  specialInvoiceCategory?: number; // Ειδική Κατηγορία Παραστατικού, Ελάχιστη τιμή = 1, Μέγιστη τιμή = 10
  invoiceVariationType?: number; // Τύπος Απόκλισης (Διαφοροποίησης) Παραστατικού, Ελάχιστη τιμή = 1 Μέγιστη τιμή = 4 (Δεν επιτρέπεται στη περίπτωση αποστολής μέσω παρόχων)
  // otherCorrelatedEntities: EntityType; // Λοιπές συσχετιζόμενες οντότητες
  otherDeliveryNoteHeader?: {
    loadingAddress: AddressType;
    deliveryAddress: AddressType;
    startShippingBranch?: number;
    completeShippingBranch?: number;
  };
}

// invoiceType values
// Λίστα τιμών: [1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 2.1, 2.2, 2.3, 2.4, 3.1, 3.2, 4, 5.1, 5.2, 6.1, 6.2, 7.1, 8.1, 8.2, 11.1, 11.2, 11.3, 11.4, 11.5, 12, 13.1, 13.2, 13.3, 13.4, 13.30, 13.31, 14.1, 14.2, 14.3, 14.4, 14.5, 14.30, 14.31, 15.1, 16.1, 17.1, 17.2, 17.3, 17.4, 17.5, 17.6.]
// [Για την περίπτωση των παρόχων μόνο οι τιμές 1.1 έως 11.5 είναι επιτρεπτές]

export interface InvoiceRowType {
  lineNumber: number;
  recType?: number;
  itemCode?: string;
  itemDescr?: string;
  quantity?: number;
  measurementUnit?: number;
  netValue: number;
  vatCategory: number;
  vatAmount: number;
  discountOption?: boolean;
  incomeClassification?: ClassificationType | ClassificationType[];
  expensesClassification?: ClassificationType | ClassificationType[];
}

interface ClassificationType {
  /** Στο JSON εμφανίζονται με το πρόθεμα του namespace */
  'icls:classificationType'?: string;
  'icls:classificationCategory'?: string;
  'icls:amount': number;
  'icls:id'?: number;
  // Αντίστοιχα για έξοδα:
  'ecls:classificationType'?: string;
  'ecls:classificationCategory'?: string;
  'ecls:amount'?: number;
}

interface InvoiceSummaryType {
  totalNetValue: number;
  totalVatAmount: number;
  totalWithheldAmount: number;
  totalFeesAmount: number;
  totalStampDutyAmount: number;
  totalOtherTaxesAmount: number;
  totalDeductionsAmount: number;
  totalGrossValue: number;
  incomeClassification?: ClassificationType | ClassificationType[];
  expensesClassification?: ClassificationType | ClassificationType[];
}

interface PaymentMethodDetailType {
  type: number; // 1-8 [cite: 2613]
  amount: number; // Decimal, minVal = 0, 2 decimal points
  paymentMethodInfo?: string; // πχ Αρ. Λογαριασμού Τραπέζης
  tipAmount?: number;
  transactionId?: string;
  tid?: string;
}

interface TaxTotalsType {
  taxType: number;
  taxCategory?: number;
  underlyingValue?: number;
  taxAmount: number;
  id?: number;
}
